<ng-container *ngFor="let reactionType of uniqueReactionTypes| keyvalue: valueLengthDescOrder">
  <ngx-emoji [emoji]="reactionType.key|reactionClassMap" size="16"></ngx-emoji>
</ng-container>
